import { render, staticRenderFns } from "./ActualizarServiciosPuertosModal.vue?vue&type=template&id=be1ce4b8"
import script from "./ActualizarServiciosPuertosModal.vue?vue&type=script&lang=js"
export * from "./ActualizarServiciosPuertosModal.vue?vue&type=script&lang=js"
import style0 from "./ActualizarServiciosPuertosModal.vue?vue&type=style&index=0&id=be1ce4b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports